import { z } from "zod";

export namespace ApiMetaSchemas {
  export const countSchema = <Schema extends z.ZodSchema>(objectSchema: Schema) =>
    z.object({
      count: z.number().gte(0),
      pageNumber: z.number().gte(0),
      pageSize: z.number().gte(0),
      data: z.array(objectSchema),
    });

  export const pageQuerySchema = (pageSize: number) =>
    z.object({
      pageNumber: z.coerce.number().gt(0, { message: "Page number must be 1 or greater." }),
      pageSize: z.coerce
        .number()
        .gt(0)
        .lte(pageSize, { message: `Page size must be between 1 and ${pageSize}, inclusive.` }),
    });
}

export namespace ApiErrorSchemas {
  export const errorSchema = z.object({
    message: z.string(),
  });
  export const serverErrorSchema = z.object({
    message: z.literal("Internal Server Error."),
  });
  export const unauthorizedErrorSchema = z.object({
    message: z.literal("Unauthorized."),
  });
}
